export default __webpack_public_path__ + "static/media/halo-4.5c35ed1c.png";